import React from "react";
import { Route, Switch } from "react-router-dom";
import GlobalContext from "./GlobalContext";

import Greeting from "./screens/Greeting";
import Confirm from "./screens/Confirm";
import InfoOne from "./screens/InfoOne";
import InfoTwo from "./screens/InfoTwo";
import Intro from "./screens/Intro";
import Surveys from "./screens/Surveys";
import Separator from "./screens/Separator";
import Success from "./screens/Success";
import Done from "./screens/Done";
import Finish from "./screens/Finish";
import ScrollToTop from "./global/ScrollToTop";
import NoToken from "./NoToken";
import "./App.css";

function App({ match }) {
  const token = match.params.tokenCode;
  return (
    <GlobalContext token={token}>
      <div id="app__wrap">
        <ScrollToTop>
          <Switch>
            <Route exact component={Greeting} path={"/token/" + token + "/"} />
            <Route
              exact
              component={Greeting}
              path={"/token/" + token + "/greeting"}
            />
            <Route
              exact
              component={Confirm}
              path={"/token/" + token + "/confirm"}
            />
            <Route
              exact
              component={InfoOne}
              path={"/token/" + token + "/info-1"}
            />
            <Route
              exact
              component={InfoTwo}
              path={"/token/" + token + "/info-2"}
            />
            <Route
              exact
              component={Intro}
              path={
                "/token/" +
                token +
                "/intro/:surveyType/:surveyNumber/:topicNumber/:screenNumber"
              }
            />
            <Route
              exact
              component={Surveys}
              path={
                "/token/" +
                token +
                "/survey/:surveyType/:surveyNumber/:topicNumber/:screenNumber"
              }
            />
            <Route
              exact
              component={Separator}
              path={
                "/token/" +
                token +
                "/separator/:surveyType/:surveyNumber/:topicNumber/:screenNumber"
              }
            />
            <Route
              exact
              component={Success}
              path={"/token/" + token + "/success"}
            />
            <Route exact component={Done} path={"/token/" + token + "/done"} />
            <Route
              exact
              component={Finish}
              path={"/token/" + token + "/finished"}
            />
            <NoToken />
          </Switch>
        </ScrollToTop>
      </div>
    </GlobalContext>
  );
}

export default App;
